import styles from "../../assets/styles/MimaInput.module.scss";
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import * as inputStyles from "./styles";

const propTypes = {
  labelTitle: PropTypes.string,
  type: PropTypes.oneOf([
    "text",
    "email",
    "number",
    "password",
    "radio",
    "date",
    "textarea",
    "tel",
    "time",
  ]),
  placeholder: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf([
    "medium",
    "wide",
    "form",
    "mobile",
    "message",
    "exchange",
    "form2",
    "error",
  ]),
  width: PropTypes.any,
  mt: PropTypes.number,
  mr: PropTypes.number,
  mb: PropTypes.number,
  ml: PropTypes.number,
  error: PropTypes.any,
  touched: PropTypes.any,
  fontSize: PropTypes.number,
  handleFilter: PropTypes.func,
  note: PropTypes.string,
};

export const MimaDateFilter = ({
  labelTitle,
  placeholder,
  onBlur,
  onChange,
  value,
  disabled = false,
  type = "text",
  variant = "medium",
  width,
  height,
  id,
  name,
  mt,
  mr,
  mb,
  ml,
  touched,
  error,
  ...props
}) => {
  // const [selectedDate, setSelectedDate] = useState(null);

  return (
    <DivSkeleton mt={mt} mb={mb} mr={mr} ml={ml} width={width}>
      <label className={styles.form__label}>{labelTitle}</label>

      <DatePicker
        // selected={selectedDate}
        // onChange={value => setSelectedDate(value)}
        dateFormat="dd/MM/yyyy"
        showYearDropdown
        scrollableYearDropdown
        className={styles.form__input_filter}
        placeholderText="dd/mm/yyyy"
        calendarClassName={styles.form__calendar}
        onBlur={onBlur}
        disabled={disabled}
        onChange={onChange}
        selected={value}
        id={id}
        name={name}
        error={error}
        {...props}
        autoComplete="off"
      />

      {error ? <div className={styles.error}>{touched && error}</div> : null}
    </DivSkeleton>
  );
};

const DivSkeleton = styled.div`
  ${inputStyles.divBase};
  ${(props) => (props.mt ? `margin-top: ${props.mt}rem` : "")};
  ${(props) => (props.mr ? `margin-right: ${props.mr}rem` : "")};
  ${(props) => (props.mb ? `margin-bottom: ${props.mb}rem` : "")};
  ${(props) => (props.ml ? `margin-left: ${props.ml}rem` : "")};
  ${(props) => (props.fontSize ? `font-size: ${props.fontSize}rem` : "")};
  ${(props) => (props.width ? `width: ${props.width}rem` : "")};
`;

MimaDateFilter.propTypes = propTypes;

export default MimaDateFilter;
